﻿import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { Clock, Loader2, Shield } from "lucide-react";

export function AuditLogs({
  logs,
  isLoading,
}: {
  logs: any[];
  isLoading: boolean;
}) {
  return (
    <div className="bg-slate-900 border border-slate-800 rounded-xl overflow-hidden shadow-sm mt-6">
      <div className="p-4 border-b border-slate-800 bg-slate-900/50 flex justify-between items-center">
        <h2 className="font-bold text-slate-200">
          Últimos 50 Registros de Auditoria
        </h2>
      </div>

      <div className="overflow-x-auto">
        {isLoading ? (
          <div className="p-12 text-center text-slate-500">
            <Loader2 className="mx-auto mb-2 animate-spin" size={24} />
            Carregando logs...
          </div>
        ) : logs.length === 0 ? (
          <div className="p-12 text-center text-slate-500">
            <Shield className="mx-auto mb-2 opacity-50" size={32} />
            Nenhum log de auditoria encontrado nos últimos 90 dias.
          </div>
        ) : (
          <table className="w-full text-left text-sm">
            <thead className="bg-slate-800/50 text-slate-400">
              <tr>
                <th className="p-4 font-semibold w-48">Data/Hora</th>
                <th className="p-4 font-semibold w-40">Responsável</th>
                <th className="p-4 font-semibold w-48">Módulo (Ação)</th>
                <th className="p-4 font-semibold">Detalhes</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-800/50 text-slate-300">
              {logs.map((log: any) => (
                <tr
                  key={log.id}
                  className="hover:bg-slate-800/30 transition-colors"
                >
                  <td className="p-4 whitespace-nowrap">
                    <div className="flex items-center gap-2">
                      <Clock size={14} className="text-slate-500" />
                      {format(new Date(log.timestamp), "dd/MM/yyyy HH:mm", {
                        locale: ptBR,
                      })}
                    </div>
                  </td>
                  <td className="p-4 font-medium text-slate-200">{log.role}</td>
                  <td className="p-4">
                    <span className="text-xs bg-slate-800 border border-slate-700 px-2 py-1 rounded text-slate-300 font-semibold uppercase tracking-wider">
                      {log.type.replace("_", " ")}
                    </span>
                  </td>
                  <td className="p-4 text-slate-400">{log.details}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
